import React from "react";

import { ArrowRight } from "react-feather";
import { makeStyles } from "@material-ui/core";

import { SupportButtonProps } from "./types";

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.common.black,
    background: theme.palette.grey[100],
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "4px",
    padding: theme.spacing(2),
    width: "100%",
    border: "none",
    fontFamily: theme.typography.fontFamily,
    textAlign: "left",
    marginTop: "8px",
    "&:hover": {
      background: theme.palette.grey[200],
    },
  },

  subtitle: {
    display: "block",
    color: theme.palette.primary.main,
    fontSize: "0.9em",
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const SupportButton: React.FC<SupportButtonProps> = ({
  onClick = () => {},
  title,
  subtitle,
}) => {
  const classes = useStyles();
  return (
    <button
      className={classes.root}
      onClick={onClick}
      data-test="support-button"
    >
      <div>
        {title}
        <span className={classes.subtitle}>{subtitle}</span>
      </div>
      <ArrowRight />
    </button>
  );
};

export default SupportButton;
